import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{rankingData.title}</h2>
          <p className="text-sm text-foreground-500">{rankingData.subtitle}</p>
        </div>
        <div className="space-y-2">
          {rankingData.items.map((item) => (
            <div key={item.rank} className="flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl px-4 py-3.5 hover:border-primary-200 transition-colors cursor-pointer group">
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">{item.title}</span>
              <span className="text-xs text-foreground-500 shrink-0">{item.heat}</span>
              <span className="w-5 h-5 flex items-center justify-center shrink-0">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400 text-sm"></i>}
                {item.trend === 'new' && <span className="text-[10px] font-bold text-accent-500">NEW</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}